import { settings } from '@pixi/settings';
export { settings } from '@pixi/settings';

settings.RETINA_PREFIX = /@([0-9\.]+)x/;
settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;
//# sourceMappingURL=settings.mjs.map
